import 'css-chunksrc/client/scenes/workloads/wbs/milestone/dateForm/dateTimeInput/styles.scss';export default {
  "dateTimeInput": "_dateTimeInput_1c1ts_1",
  "input": "_input_1c1ts_6",
  "placeholder": "_placeholder_1c1ts_22",
  "value": "_value_1c1ts_27",
  "calendarInput": "_calendarInput_1c1ts_32",
  "calendar": "_calendar_1c1ts_32",
  "timeList": "_timeList_1c1ts_48",
  "timeListWrapper": "_timeListWrapper_1c1ts_57",
  "time": "_time_1c1ts_48",
  "timeName": "_timeName_1c1ts_69",
  "invalid": "_invalid_1c1ts_75",
  "disabled": "_disabled_1c1ts_83"
};